import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';

export type DialogFooterVariant = 'primary' | 'danger';

@Component({
  selector: 'app-dialog-footer',
  standalone: true,
  imports: [MatDialogModule],
  templateUrl: './dialog-footer.component.html',
  styleUrl: './dialog-footer.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DialogFooterComponent {
  /** Value passed to `[mat-dialog-close]` on confirm. Bind whatever the parent needs returned. */
  readonly dialogResult = input<unknown>();
  readonly confirmLabel = input<string>('موافق');
  readonly cancelLabel = input<string>('إلغاء');
  readonly showConfirm = input<boolean>(true);
  readonly confirmVariant = input<DialogFooterVariant>('primary');
  /** Optional extra class applied to the `mat-dialog-actions` wrapper (e.g. `setup-footer`). */
  readonly wrapperClass = input<string>('');
}
